module.exports = __webpack_public_path__ + "img/L_KD.d45953c0.png";